module.exports = __webpack_public_path__ + "img/78.c2a20084.jpg";